"use client"

import { ThemeProvider } from "@/context/ThemeContext";
import React from "react";

export default function AuthLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <ThemeProvider>
      <div className="relative w-full min-h-screen bg-white dark:bg-gray-900">
        {children}
      </div>
    </ThemeProvider>
  );
}